<app-widget-card-wrapper [title]="chartTitle" [hide]="!hasData" [subTitle]="chartSubtitle">
  <div class="card-stretch text-center">
    <div [id]="id" echarts [options]="chartOptions" *ngIf="chartOptions" theme="macarons" class="chart-container"></div>
  </div>
</app-widget-card-wrapper>
